import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Link, NavLink } from "react-router-dom";
import guLocale from "../locales/gu";

const Sidebar = () => {
  const locale = guLocale.sidebar;
  const navigate = useNavigate();
  const { logout, isAdminUser } = useAuth();

  const handleLogout = async () => {
    logout();
    navigate("/login");
  };

  return (
    <div>
      <aside className="main-sidebar sidebar-light-primary elevation-4">
        <Link to="/" className="brand-link">
          <img
            src="../dist/img/logos/dark-logo-6.png"
            alt="Easy Rojmel"
            className="w-100"
          />
        </Link>
        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to={isAdminUser ? "/admin/dashboard" : "/dashboard"}
                >
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>{locale.dashboardLink}</p>
                </NavLink>
              </li>
              {isAdminUser && (
                <>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/admin/users"
                    >
                      <i className="nav-icon fas fa-users" />
                      <p>{locale.users}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/admin/heads"
                    >
                      <i className="nav-icon fas fa-graduation-cap" />
                      <p>{locale.headsLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/admin/ledgers"
                    >
                      <i className="nav-icon fas fa-book" />
                      <p>{locale.ledgersLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/admin/approval-requests"
                    >
                      <i className="nav-icon fas fa-clock" />
                      <p>{locale.approvalRequests}</p>
                    </NavLink>
                  </li>
                </>
              )}
              {!isAdminUser && (
                <>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/heads"
                    >
                      <i className="nav-icon fas fa-graduation-cap" />
                      <p>{locale.headsLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/ledgers"
                    >
                      <i className="nav-icon fas fa-book" />
                      <p>{locale.ledgersLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/reports"
                    >
                      <i className="nav-icon fas fa-chart-line" />
                      <p>{locale.reportsLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-header">{locale.extrasHeader}</li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/profiles">
                      <i className="nav-icon fas fa-user" />
                      <p>{locale.profileSettingsLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/how-to-use"
                    >
                      <i className="nav-icon far fa-question-circle" />
                      <p>{locale.howToUseLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/call-us"
                    >
                      <i className="nav-icon fas fa-phone-alt" />
                      <p>{locale.callUsLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/about-us"
                    >
                      <i className="fas fa-info-circle nav-icon" />
                      <p>{locale.aboutUsDropdown}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/privacy-policy"
                    >
                      <i className="nav-icon far fas fa-shield-alt"/>
                      <p>{locale.privacyPolicyLink}</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to="/terms-conditions"
                    >
                      <i className="nav-icon fas fa-file-contract" />
                      <p>{locale.termsConditionsLink}</p>
                    </NavLink>
                  </li>
                </>
              )}
              <li className="nav-item">
                <Link className="nav-link" onClick={handleLogout}>
                  <i className="nav-icon fas fa-sign-out-alt" />
                  <p>{locale.logoutLink}</p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
